import { COPY_POLICIES, DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const PROMO_MAX_LENGTHS = {
    eyebrow: 20,
    title: COPY_POLICIES.title.maxLength,
    description: COPY_POLICIES.description.maxLength,
};
export const promoSchema = {
    componentId: "Promo",
    scalarSlots: [
        {
            key: "eyebrow",
            label: "Eyebrow",
            type: "text",
            maxLength: PROMO_MAX_LENGTHS.eyebrow,
        },
        { key: "title", ...TITLE_COPY_LIMITS, label: "Title", type: "text" },
        { key: "ctaLabel", label: "CTA label", type: "text" },
        { key: "ctaHref", label: "CTA url", type: "url" },
    ],
    mediaSlots: [],
    documentSlots: [
        { key: "description", ...DESCRIPTION_COPY_LIMITS, label: "Description" },
    ],
};
//# sourceMappingURL=promo.js.map